import { theme as defaultTheme } from '@chakra-ui/react';

export const breakpoints = defaultTheme.breakpoints;
type TBreakpoint = keyof (typeof defaultTheme)['breakpoints'];

export const themeBreakpoints = {
  up: (breakpoint: TBreakpoint) => {
    return `@media (min-width: ${defaultTheme.breakpoints[breakpoint]})`;
  },
  down: (breakpoint: TBreakpoint) => {
    return `@media (max-width: ${defaultTheme.breakpoints[breakpoint]})`;
  },
};
